import { isMagicbuyProject } from './projectUtils'

export const MAGICBUY_DISPLAY_WHS_ADDRID = '1596'

export { isMagicbuyProject }

export function getParcelDisplayWhsAddrid (parcel, project) {
  // 买即可东莞包裹保留原仓分组，其他已入库包裹继续归到漳州。
  if (isMagicbuyProject(project) && parcel?.isStorage && parcel.jyAddrid !== '2769') {
    return MAGICBUY_DISPLAY_WHS_ADDRID
  }
  return parcel?.jyAddrid || ''
}

export function isParcelInDisplayWhs (parcel, choseWhsAddrid, project) {
  if (!choseWhsAddrid) {
    return true
  }
  return getParcelDisplayWhsAddrid(parcel, project) === choseWhsAddrid
}

export function getParcelDisplayWhsAddrids (parcels, project) {
  return [...new Set(parcels.map(parcel => getParcelDisplayWhsAddrid(parcel, project)))]
    .filter(addrid => addrid)
}

export function canShowTransitLabel (parcel, project) {
  if (isMagicbuyProject(project)) {
    return false
  }
  if (!parcel || !parcel.extraInfo) {
    return false
  }
  return parcel.status === 'stored' &&
    parcel.jyAddrid === MAGICBUY_DISPLAY_WHS_ADDRID &&
    parcel.extraInfo.jyAddridFwd === 'zzhou'
}
